import { z } from 'zod';
import type { StoryblokAsset } from '~storyblok-types/storyblok';

export type AcademyImage = Pick<StoryblokAsset, 'src'> &
    Partial<Pick<StoryblokAsset, 'alt' | 'title' | 'width' | 'height' | 'focus'>>;

export const AcademyImageSchema: z.ZodType<AcademyImage> = z.object({
    src: z.string(),
    alt: z.string().nullish(),
    title: z.string().nullish(),
    width: z.number().nullish(),
    height: z.number().nullish(),
    focus: z.string().nullish()
});

/** @deprecated Use AcademyImage */
export type StoryblokLikeImage = AcademyImage;

type _AssertAcademyImageUsesStoryblokFields = keyof AcademyImage extends keyof StoryblokAsset ? true : never;
const _assertAcademyImageUsesStoryblokFields: _AssertAcademyImageUsesStoryblokFields = true;
void _assertAcademyImageUsesStoryblokFields;
